import { PasswordValidation } from '../components/shared/PasswordValidationDisplay';

export const validatePassword = (password: string): PasswordValidation => {
  return {
    length: password.length >= 8,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /\d/.test(password),
    special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
  };
};

export const isPasswordValid = (validation: PasswordValidation): boolean => {
  return Object.values(validation).every(Boolean);
};

export const getPasswordStrength = (
  validation: PasswordValidation,
): {
  score: number;
  label: string;
  color: string;
} => {
  const score = Object.values(validation).filter(Boolean).length;

  if (score === 5) {
    return { score: 5, label: 'Very Strong', color: 'text-green-600' };
  } else if (score === 4) {
    return { score: 4, label: 'Strong', color: 'text-green-500' };
  } else if (score === 3) {
    return { score: 3, label: 'Medium', color: 'text-yellow-500' };
  } else if (score >= 2) {
    return { score: 2, label: 'Weak', color: 'text-orange-500' };
  } else {
    return { score: 1, label: 'Very Weak', color: 'text-red-500' };
  }
};
